// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page.BC-Page__CountdownList .premium-lock-card img {
    margin: auto;
    margin-bottom: 16px;
    display: block;
}

.BC-Page.BC-Page__CountdownList .premium-lock-card h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
    text-align: center;
}

.BC-Page.BC-Page__CountdownList .premium-lock-card h3 {
    font-size: 16px;
    font-weight: 600;
}

.BC-Page.BC-Page__CountdownList .premium-lock-card__button {
    display: flex;
    justify-content: center;
    gap: 16px;
    align-items: center;
    margin-top: 16px;
}

.BC-Page.BC-Page__CountdownList .premium-lock-card__button .Polaris-Button {
    background-color: #FFC96B;
    color: #202223;
    margin-right: 0;
}

.BC-Page.BC-Page__CountdownList .premium-lock-card__button .Polaris-Button .Polaris-Button__Text {
    display: flex;
    align-items: center;
    gap: 6px;
    justify-content: center;
}

.BC-Page.BC-Page__CountdownList .premium-lock-card__button .Polaris-Link {
    display: flex;
    align-items: center;
}

.BC-Page.BC-Page__CountdownList .BC-Filters .BC-Filters-ConnectedFilterControl {
    display: flex;
    gap: 8px;
}

.BC-Page.BC-Page__CountdownList .BC-Filters .BC-Filters-ConnectedFilterControl .BC-Filters-ConnectedFilterControl__RightContainer {
    flex-grow: 1;
}

.BC-Popover__Countdown-Filters-Options {
    min-width: 204px;
}

.BC-Popover__Countdown-Filters-Options .Polaris-ChoiceList ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.BC-Popover__Countdown-Filters-Market .Polaris-ChoiceList ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
}

.BC-Page__CountdownList .Polaris-DataTable__Table .group_btn .Polaris-Button--plain svg {
    fill: var(--p-icon);
}

.BC-Popover__Countdown-Filters-Options .Polaris-ChoiceList ul li {
    margin-right: 1.25rem;
}

.BC-Popover__Countdown-Filters-EditColumn {
    min-width: 12rem;
}

.Polaris-Popover__Wrapper .Polaris-Popover__Section {
    padding: 20px;
}

.BC-Popover__Countdown-Filters-Options legend {
    margin-bottom: 12px;
}

.BC-Popover__Countdown-Filters-Options legend,
.BC-Popover__Countdown-Filters-Options .Polaris-Label__Text {
    font-weight: 500;
}

.BC-Page__CountdownList .Polaris-Card .Polaris-Card__Section .noRules {
    min-height: 370px;
}

.BC-Popover__Countdown-Filters-Options .breakLine,
.BC-Popover__Countdown-Filters-Market .breakLine {
    padding: 16px 0 0 0;
    display: flex;
    justify-content: space-between;
}

.BC-EmptyRules__Countdown {
    min-height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.BC-EmptyRules__Countdown h3 {
    margin-bottom: 4px;
    font-weight: 600;
    font-size: 16px;
}

.BC-EmptyRules__Countdown img {
    width: 50px;
    margin-bottom: 16px;
}

.BC-Page__CountdownList .BC-CountdownList .Polaris-Card__Section--fullWidth {
    padding: 0;
}

.BC-Page__CountdownList .BC-CountdownList .Polaris-DataTable thead .Polaris-DataTable__Cell.Polaris-DataTable__Cell--verticalAlignTop {
    font-weight: 500;
}

.BC-Page__CountdownList .BC-CountdownList .Polaris-DataTable .Polaris-DataTable__Cell--firstColumn.Polaris-DataTable__Cell--header {
    width: 80px;
}

.BC-Page__CountdownList .BC-CountdownList .Polaris-DataTable .Polaris-DataTable__Cell.Polaris-DataTable__Cell--verticalAlignTop:nth-child(2) {
    width: 200px;
}

.BC-Page__CountdownList .BC-CountdownList .Polaris-DataTable .Polaris-DataTable__Cell.Polaris-DataTable__Cell--verticalAlignTop:nth-child(3) {
    width: 159px;
}

.BC-Page__CountdownList .BC-CountdownList .Polaris-DataTable .Polaris-DataTable__Cell.Polaris-DataTable__Cell--verticalAlignTop:nth-child(5) {
    width: 90px;
}

.BC-Page__CountdownList .BC-CountdownList .Polaris-Card__Section--fullWidth .Polaris-SkeletonDisplayText__DisplayText {
    width: 100%;
    max-width: 100%;
}

.BC-Page__CountdownList .BC-CountdownList .Polaris-Link {
    text-decoration: none;
}

.BC-Page__CountdownList .BC-CountdownList .countdown-placements {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.BC-Page__CountdownList .BC-CountdownList .countdown-placement-item {
    background-color: #EDEEEF;
    padding: 2px 8px;
    border-radius: 4px;
    color: #6D7175;
    font-size: 12px;
    text-align: center;
}

.BC-Page__CountdownList .BC-CountdownList .Polaris-Button--sizeSlim {
    padding: 4px;
    min-width: 28px;
}

.BC-Page__CountdownList .BC-CountdownList .Polaris-ButtonGroup__Item .Polaris-Icon {
    width: 16px;
    height: 16px;
}

.BC-Page__CountdownList .BC-CountdownList .BC-Page__CountdownList__Pagination {
    display: flex;
    justify-content: center;
    margin-top: 24px;
}


.BC-Page__CountdownList .BC-CountdownList .BC-Page__CountdownList__Pagination .Polaris-ButtonGroup__Item:nth-child(2) .Polaris-Button--outline[aria-disabled="true"] {
    border-left-color: var(--p-border);
}

.BC-Page__CountdownNewModal {
    padding-bottom: 40px;
}

.BC-Page__CountdownNewModal.BC-Page__CountdownNewModal--scroll-inside {
    height: calc(100vh - 60px);
    padding-bottom: 0;
}

.BC-Page__CountdownNewModal .Polaris-Page {
    margin-top: 16px;
}

/* .BC-Page__CountdownNewModal .Polaris-Page {
    height: calc(100vh - 61px);
    display: flex;
    place-items: center;
}


.BC-Page__CountdownNewModal .Polaris-Page .Polaris-Page__Content {
    padding-top: 0;
} */

.BC-Page__CountdownNewModal>.Polaris-Spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.BC-Page__CountdownNewModal .countdown-type-option {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-left: 32px;
}

.BC-Page__CountdownNewModal .countdown-type-option .countdown-type-option__title {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
}

.BC-Page__CountdownNewModal .countdown-type-option .countdown-type-option__coming-soon {
    background-color: #E0F0FF;
    border-color: 8px;
    color: #00527C;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 8px;
}

.BC-Page__CountdownNewModal .countdown-type-option p {
    text-align: center;
}

.BC-Page__CountdownNewModal .countdown-type-option img {
    max-width: 310px;
}

.BC-Page__CountdownNewModal .countdown-type-option__wrapper {
    padding: 10px;
    border: 1px solid transparent;
    border-radius: 8px;
}

.BC-Page__CountdownNewModal .countdown-type-option__wrapper--active {
    border: 1px solid #1F5199;
    background-color: #E5EFFD;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .Polaris-Label__Text {
    font-weight: 600;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .Polaris-Labelled__HelperText {
    color: #6D7175;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-placement-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-left: 16px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-placement-options .Polaris-Choice {
    max-width: max-content;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options__specific-config {
    background-color: #F6F6F7;
    padding: 12px;
    border-radius: 6px;
    margin-left: 28px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options {
    padding-left: 24px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .countdown-apply-to-options__inner {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
    margin-bottom: 8px;
}


.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .product-list {
    background-color: #fff;
    border-radius: 8px;
    border-width: 1px;
    border-style: dashed;
    border-color: #E1E3E5;
    margin-top: 4px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list {
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
    max-height: 282px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list .product-item {
    padding: 8px 16px;
    border-top: 1px solid #E1E3E5;
}


.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .rule-group-block .content-list .product-item {
    padding-left: 12px;
    padding-right: 12px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list .product-item:first-child {
    border-top: none;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list .product-item::marker {
    content: '';
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list .product-item__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list .product-item__inner .product-item__info {
    display: flex;
    align-items: center;
    gap: 8px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-name .Polaris-Connected {
    padding-left: 16px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-name .Polaris-Labelled__HelperText {
    padding-left: 16px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
    padding-left: 16px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box {
    padding: 12px;
    background-color: #F6F6F7;
    border-radius: 6px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 16px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__start-date {
    grid-column: span 3;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__end-date {
    grid-column: span 3;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__minutes {
    grid-column: span 6;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__once-end {
    grid-column: span 6;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .date-select .Polaris-Button__Text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .date-select .Polaris-Button__Text .Polaris-Icon {
    margin: 0;
    width: 16px;
    height: 16px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .Polaris-Label__Text {
    font-weight: 400;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily {
    grid-column: span 6;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .Polaris-Icon {
    margin: 0;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .rc-time-picker {
    display: flex;
    width: 100%;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .rc-time-picker-input {
    font-size: var(--p-font-size-5);
    font-weight: var(--p-font-weight-regular);
    line-height: var(--p-line-height-3);
    border: none;
    text-transform: initial;
    letter-spacing: initial;
    position: relative;
    z-index: var(--pc-text-field-contents);
    display: block;
    flex: 1 1;
    width: 100%;
    min-width: 0;
    min-height: 2.25rem;
    margin: 0;
    padding: calc((var(--p-line-height-6) - var(--p-line-height-3) - var(--p-space-05))/2) var(--p-space-3);
    background: none;
    border: var(--p-border-transparent);
    font-family: var(--p-font-family-sans);
    -webkit-appearance: none;
    appearance: none;
    caret-color: var(--p-text);
    color: var(--p-text);
    height: auto;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .rc-time-picker-input:focus {
    outline: none;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .rc-time-picker:has(.rc-time-picker-input:focus)~.Polaris-TextField__Backdrop::after {
    box-shadow: 0 0 0 0.125rem var(--p-focused);
    outline: var(--p-border-width-1) solid transparent;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-status {
    max-width: 288px;
}

.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-status #status {
    padding-left: 16px;
}

.BC-Page__CountdownNewModal .options-preview {
    align-items: center;
    display: flex;
    height: 100%;
}

.BC-Page__CountdownNewModal .options-preview-label {
    margin-right: 20px;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
}


.BC-Page__CountdownNewModal .select-option-preview {
    min-width: 280px;
}

.BC-Page__CountdownNewModal .BC-CountdownVisualEditor {
    display: flex;
    gap: 16px;
    height: 100%;
}

.BC-Page__CountdownNewModal .countdown-left-side {
    width: 300px;
    height: 100%;
    padding: 16px 16px;
    padding-bottom: 40px;
    background-color: #fff;
    border-right: 1px solid #E1E3E5;
    display: flex;
    flex-direction: column;
    gap: 16px;
    z-index: 1;
    overflow: auto;
    height: 100%;
}

.BC-Page__CountdownNewModal .countdown-left-side .countdown-left-side__item__inner {
    display: flex;
    gap: 8px;
    margin-top: 4px;
}

.BC-Page__CountdownNewModal .countdown-left-side .Polaris-ResourceList__Badge.selectedColor {
    width: 24px;
    height: 24px;
    border: 1px solid #6D7175;
    border-radius: 2px;
    position: relative;
    z-index: 99;
    margin-left: 12px;
}

.BC-Page__CountdownNewModal .countdown-left-side .text-size {
    width: 96px;
    flex-shrink: 0;
}

.BC-Page__CountdownNewModal .countdown-preview-side__product-page {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
}

.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content {
    height: calc(100% - 72px);
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 16px 0;
}

.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box {
    /* border: 1px solid #C9CCCF; */
    box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000D;
    padding: 20px 24px;
    border-radius: 8px;
    max-width: 400px;
}

.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .title {
    font-weight: 700;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    line-height: normal;
}

.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .subheading {
    margin-top: 8px;
    font-size: 14px;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    line-height: normal;
}

.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .block-timer {
    display: flex;
    margin-top: 16px;
    gap: 6px;
    justify-content: center;
}

.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .block-timer__item {
    padding: 16px 12px 12px;
    border-radius: 10px;
    background: linear-gradient(180deg, rgba(197, 197, 197, 0.5) 0%, rgba(197, 197, 197, 0.05) 100%);
    backdrop-filter: blur(65px);
    display: flex;
    flex-direction: column;
}

.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .block-timer__item .time {
    font-weight: 600;
    text-align: center;
}

.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .block-timer__item .time-label {
    font-size: 12px;
    text-align: center;
    margin-top: 16px;
}

.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .two-dots {
    font-size: 36px;
    font-weight: 600;
    line-height: 48px;
}

.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .countdown-preview-side__product-page__button {
    margin-top: 16px;
    font-weight: 500;
    padding: 10px;
    width: 100%;
    border-radius: 4px;
    border: 0;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    line-height: normal;
}


.BC-Page__CountdownNewModal .BC-CountdownReviewAppBlock .Polaris-Page {
    background-color: #fff;
    padding: 24px;
}

.BC-Page__CountdownNewModal .BC-CountdownReviewAppBlock .Polaris-Page .Polaris-Page__Content {
    padding: 0;
}

.BC-CountdownReviewAppBlock__Head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.BC-CountdownReviewAppBlock__Steps {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.BC-CountdownReviewAppBlock__Step {
    border-radius: 12px;
    overflow: hidden;
    background: #FAFBFB;
}

.BC-CountdownReviewAppBlock__Step.open {
    border-color: var(--p-border, #c9cccf);
}

.BC-CountdownReviewAppBlock__StepActivator {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    cursor: pointer;
    user-select: none;
}

.BC-CountdownReviewAppBlock__StepActivator:hover {
    background-color: var(--p-surface-hovered, #f6f6f7);
}


.BC-CountdownReviewAppBlock__StepActivator .BC-CountdownReviewAppBlock__Incomplete {
    border: 2px dashed #8C9196;
    border-radius: 50%;
    width: 18px;
    height: 18px;
}

.BC-CountdownReviewAppBlock__StepTitle {
    font-size: 14px;
    font-weight: 600;
    color: var(--p-text, #202223);
    display: flex;
    gap: 8px;
    align-items: center;
}

.BC-CountdownReviewAppBlock__StepTitle .Polaris-Icon {
    margin: 0;
}

.BC-CountdownReviewAppBlock__StepToggle {
    flex-shrink: 0;
}

.BC-CountdownReviewAppBlock__StepContent {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 24px;
    padding: 0 20px 20px;
}

.BC-CountdownReviewAppBlock__StepLeft {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.BC-CountdownReviewAppBlock__StepLeft p {
    margin: 0;
    line-height: 1.5;
}

.BC-CountdownReviewAppBlock__StepLeft ul {
    padding-left: 16px;
}

.BC-CountdownReviewAppBlock__StepRight {
    flex-shrink: 0;
    max-width: 340px;
}

.BC-CountdownReviewAppBlock__StepRight img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    border: 1px solid var(--p-border-subdued, #dde0e4);
    cursor: pointer;
}

.BC-CountdownReviewAppBlock__StepLeft .Polaris-Button {
    max-width: max-content;
}

.BC-CountdownReviewAppBlock__StepDone {
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--p-text-success, #008060);
}

.BC-CountdownReviewAppBlock__Steps .Polaris-Icon {
    margin: 0;
}

.BC-Page__CountdownNewModal .timer-wrapper .Polaris-TextField {
    padding-right: 0;
}

@media (min-width: 40em) {
    .BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .rc-time-picker-input {
        font-size: var(--p-font-size-3);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/countdown.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;;AAGA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;;;;;;GASG;;AAEH;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,kBAAkB;AACtB;;;AAGA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sCAAsC;IACtC,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,yCAAyC;IACzC,mCAAmC;IACnC,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,sCAAsC;IACtC,cAAc;IACd,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,uGAAuG;IACvG,gBAAgB;IAChB,mCAAmC;IACnC,sCAAsC;IACtC,wBAAwB;IACxB,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2CAA2C;IAC3C,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,gEAAgE;IAChE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gGAAgG;IAChG,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mDAAmD;AACvD;;;AAGA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kDAAkD;IAClD,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qCAAqC;AACzC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,+BAA+B;IACnC;AACJ","sourcesContent":[".BC-Page.BC-Page__CountdownList .premium-lock-card img {\n    margin: auto;\n    margin-bottom: 16px;\n    display: block;\n}\n\n.BC-Page.BC-Page__CountdownList .premium-lock-card h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 4px;\n    text-align: center;\n}\n\n.BC-Page.BC-Page__CountdownList .premium-lock-card h3 {\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.BC-Page.BC-Page__CountdownList .premium-lock-card__button {\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n    align-items: center;\n    margin-top: 16px;\n}\n\n.BC-Page.BC-Page__CountdownList .premium-lock-card__button .Polaris-Button {\n    background-color: #FFC96B;\n    color: #202223;\n    margin-right: 0;\n}\n\n.BC-Page.BC-Page__CountdownList .premium-lock-card__button .Polaris-Button .Polaris-Button__Text {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    justify-content: center;\n}\n\n.BC-Page.BC-Page__CountdownList .premium-lock-card__button .Polaris-Link {\n    display: flex;\n    align-items: center;\n}\n\n.BC-Page.BC-Page__CountdownList .BC-Filters .BC-Filters-ConnectedFilterControl {\n    display: flex;\n    gap: 8px;\n}\n\n.BC-Page.BC-Page__CountdownList .BC-Filters .BC-Filters-ConnectedFilterControl .BC-Filters-ConnectedFilterControl__RightContainer {\n    flex-grow: 1;\n}\n\n.BC-Popover__Countdown-Filters-Options {\n    min-width: 204px;\n}\n\n.BC-Popover__Countdown-Filters-Options .Polaris-ChoiceList ul {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.BC-Popover__Countdown-Filters-Market .Polaris-ChoiceList ul {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 8px;\n}\n\n.BC-Page__CountdownList .Polaris-DataTable__Table .group_btn .Polaris-Button--plain svg {\n    fill: var(--p-icon);\n}\n\n.BC-Popover__Countdown-Filters-Options .Polaris-ChoiceList ul li {\n    margin-right: 1.25rem;\n}\n\n.BC-Popover__Countdown-Filters-EditColumn {\n    min-width: 12rem;\n}\n\n.Polaris-Popover__Wrapper .Polaris-Popover__Section {\n    padding: 20px;\n}\n\n.BC-Popover__Countdown-Filters-Options legend {\n    margin-bottom: 12px;\n}\n\n.BC-Popover__Countdown-Filters-Options legend,\n.BC-Popover__Countdown-Filters-Options .Polaris-Label__Text {\n    font-weight: 500;\n}\n\n.BC-Page__CountdownList .Polaris-Card .Polaris-Card__Section .noRules {\n    min-height: 370px;\n}\n\n.BC-Popover__Countdown-Filters-Options .breakLine,\n.BC-Popover__Countdown-Filters-Market .breakLine {\n    padding: 16px 0 0 0;\n    display: flex;\n    justify-content: space-between;\n}\n\n.BC-EmptyRules__Countdown {\n    min-height: 250px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.BC-EmptyRules__Countdown h3 {\n    margin-bottom: 4px;\n    font-weight: 600;\n    font-size: 16px;\n}\n\n.BC-EmptyRules__Countdown img {\n    width: 50px;\n    margin-bottom: 16px;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .Polaris-Card__Section--fullWidth {\n    padding: 0;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .Polaris-DataTable thead .Polaris-DataTable__Cell.Polaris-DataTable__Cell--verticalAlignTop {\n    font-weight: 500;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .Polaris-DataTable .Polaris-DataTable__Cell--firstColumn.Polaris-DataTable__Cell--header {\n    width: 80px;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .Polaris-DataTable .Polaris-DataTable__Cell.Polaris-DataTable__Cell--verticalAlignTop:nth-child(2) {\n    width: 200px;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .Polaris-DataTable .Polaris-DataTable__Cell.Polaris-DataTable__Cell--verticalAlignTop:nth-child(3) {\n    width: 159px;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .Polaris-DataTable .Polaris-DataTable__Cell.Polaris-DataTable__Cell--verticalAlignTop:nth-child(5) {\n    width: 90px;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .Polaris-Card__Section--fullWidth .Polaris-SkeletonDisplayText__DisplayText {\n    width: 100%;\n    max-width: 100%;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .Polaris-Link {\n    text-decoration: none;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .countdown-placements {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .countdown-placement-item {\n    background-color: #EDEEEF;\n    padding: 2px 8px;\n    border-radius: 4px;\n    color: #6D7175;\n    font-size: 12px;\n    text-align: center;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .Polaris-Button--sizeSlim {\n    padding: 4px;\n    min-width: 28px;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .Polaris-ButtonGroup__Item .Polaris-Icon {\n    width: 16px;\n    height: 16px;\n}\n\n.BC-Page__CountdownList .BC-CountdownList .BC-Page__CountdownList__Pagination {\n    display: flex;\n    justify-content: center;\n    margin-top: 24px;\n}\n\n\n.BC-Page__CountdownList .BC-CountdownList .BC-Page__CountdownList__Pagination .Polaris-ButtonGroup__Item:nth-child(2) .Polaris-Button--outline[aria-disabled=\"true\"] {\n    border-left-color: var(--p-border);\n}\n\n.BC-Page__CountdownNewModal {\n    padding-bottom: 40px;\n}\n\n.BC-Page__CountdownNewModal.BC-Page__CountdownNewModal--scroll-inside {\n    height: calc(100vh - 60px);\n    padding-bottom: 0;\n}\n\n.BC-Page__CountdownNewModal .Polaris-Page {\n    margin-top: 16px;\n}\n\n/* .BC-Page__CountdownNewModal .Polaris-Page {\n    height: calc(100vh - 61px);\n    display: flex;\n    place-items: center;\n}\n\n\n.BC-Page__CountdownNewModal .Polaris-Page .Polaris-Page__Content {\n    padding-top: 0;\n} */\n\n.BC-Page__CountdownNewModal>.Polaris-Spinner {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.BC-Page__CountdownNewModal .countdown-type-option {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-left: 32px;\n}\n\n.BC-Page__CountdownNewModal .countdown-type-option .countdown-type-option__title {\n    font-weight: 600;\n    font-size: 16px;\n    margin-bottom: 6px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n}\n\n.BC-Page__CountdownNewModal .countdown-type-option .countdown-type-option__coming-soon {\n    background-color: #E0F0FF;\n    border-color: 8px;\n    color: #00527C;\n    padding: 2px 8px;\n    font-size: 12px;\n    font-weight: 500;\n    border-radius: 8px;\n}\n\n.BC-Page__CountdownNewModal .countdown-type-option p {\n    text-align: center;\n}\n\n.BC-Page__CountdownNewModal .countdown-type-option img {\n    max-width: 310px;\n}\n\n.BC-Page__CountdownNewModal .countdown-type-option__wrapper {\n    padding: 10px;\n    border: 1px solid transparent;\n    border-radius: 8px;\n}\n\n.BC-Page__CountdownNewModal .countdown-type-option__wrapper--active {\n    border: 1px solid #1F5199;\n    background-color: #E5EFFD;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .Polaris-Label__Text {\n    font-weight: 600;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .Polaris-Labelled__HelperText {\n    color: #6D7175;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-placement-options {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding-left: 16px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-placement-options .Polaris-Choice {\n    max-width: max-content;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options__specific-config {\n    background-color: #F6F6F7;\n    padding: 12px;\n    border-radius: 6px;\n    margin-left: 28px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options {\n    padding-left: 24px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .countdown-apply-to-options__inner {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .product-list {\n    background-color: #fff;\n    border-radius: 8px;\n    border-width: 1px;\n    border-style: dashed;\n    border-color: #E1E3E5;\n    margin-top: 4px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list {\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n    max-height: 282px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list .product-item {\n    padding: 8px 16px;\n    border-top: 1px solid #E1E3E5;\n}\n\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .rule-group-block .content-list .product-item {\n    padding-left: 12px;\n    padding-right: 12px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list .product-item:first-child {\n    border-top: none;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list .product-item::marker {\n    content: '';\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list .product-item__inner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-apply-to-options .content-list .product-item__inner .product-item__info {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-name .Polaris-Connected {\n    padding-left: 16px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-name .Polaris-Labelled__HelperText {\n    padding-left: 16px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type-options {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 8px;\n    padding-left: 16px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box {\n    padding: 12px;\n    background-color: #F6F6F7;\n    border-radius: 6px;\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    gap: 16px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__start-date {\n    grid-column: span 3;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__end-date {\n    grid-column: span 3;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__minutes {\n    grid-column: span 6;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__once-end {\n    grid-column: span 6;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .date-select .Polaris-Button__Text {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .date-select .Polaris-Button__Text .Polaris-Icon {\n    margin: 0;\n    width: 16px;\n    height: 16px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .Polaris-Label__Text {\n    font-weight: 400;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily {\n    grid-column: span 6;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .Polaris-Icon {\n    margin: 0;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .rc-time-picker {\n    display: flex;\n    width: 100%;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .rc-time-picker-input {\n    font-size: var(--p-font-size-5);\n    font-weight: var(--p-font-weight-regular);\n    line-height: var(--p-line-height-3);\n    border: none;\n    text-transform: initial;\n    letter-spacing: initial;\n    position: relative;\n    z-index: var(--pc-text-field-contents);\n    display: block;\n    flex: 1 1;\n    width: 100%;\n    min-width: 0;\n    min-height: 2.25rem;\n    margin: 0;\n    padding: calc((var(--p-line-height-6) - var(--p-line-height-3) - var(--p-space-05))/2) var(--p-space-3);\n    background: none;\n    border: var(--p-border-transparent);\n    font-family: var(--p-font-family-sans);\n    -webkit-appearance: none;\n    appearance: none;\n    caret-color: var(--p-text);\n    color: var(--p-text);\n    height: auto;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .rc-time-picker-input:focus {\n    outline: none;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .rc-time-picker:has(.rc-time-picker-input:focus)~.Polaris-TextField__Backdrop::after {\n    box-shadow: 0 0 0 0.125rem var(--p-focused);\n    outline: var(--p-border-width-1) solid transparent;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-status {\n    max-width: 288px;\n}\n\n.BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-status #status {\n    padding-left: 16px;\n}\n\n.BC-Page__CountdownNewModal .options-preview {\n    align-items: center;\n    display: flex;\n    height: 100%;\n}\n\n.BC-Page__CountdownNewModal .options-preview-label {\n    margin-right: 20px;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 24px;\n}\n\n\n.BC-Page__CountdownNewModal .select-option-preview {\n    min-width: 280px;\n}\n\n.BC-Page__CountdownNewModal .BC-CountdownVisualEditor {\n    display: flex;\n    gap: 16px;\n    height: 100%;\n}\n\n.BC-Page__CountdownNewModal .countdown-left-side {\n    width: 300px;\n    height: 100%;\n    padding: 16px 16px;\n    padding-bottom: 40px;\n    background-color: #fff;\n    border-right: 1px solid #E1E3E5;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    z-index: 1;\n    overflow: auto;\n    height: 100%;\n}\n\n.BC-Page__CountdownNewModal .countdown-left-side .countdown-left-side__item__inner {\n    display: flex;\n    gap: 8px;\n    margin-top: 4px;\n}\n\n.BC-Page__CountdownNewModal .countdown-left-side .Polaris-ResourceList__Badge.selectedColor {\n    width: 24px;\n    height: 24px;\n    border: 1px solid #6D7175;\n    border-radius: 2px;\n    position: relative;\n    z-index: 99;\n    margin-left: 12px;\n}\n\n.BC-Page__CountdownNewModal .countdown-left-side .text-size {\n    width: 96px;\n    flex-shrink: 0;\n}\n\n.BC-Page__CountdownNewModal .countdown-preview-side__product-page {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n}\n\n.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content {\n    height: calc(100% - 72px);\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    margin: 16px 0;\n}\n\n.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box {\n    /* border: 1px solid #C9CCCF; */\n    box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000D;\n    padding: 20px 24px;\n    border-radius: 8px;\n    max-width: 400px;\n}\n\n.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .title {\n    font-weight: 700;\n    text-align: center;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    max-width: 100%;\n    line-height: normal;\n}\n\n.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .subheading {\n    margin-top: 8px;\n    font-size: 14px;\n    text-align: center;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    max-width: 100%;\n    line-height: normal;\n}\n\n.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .block-timer {\n    display: flex;\n    margin-top: 16px;\n    gap: 6px;\n    justify-content: center;\n}\n\n.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .block-timer__item {\n    padding: 16px 12px 12px;\n    border-radius: 10px;\n    background: linear-gradient(180deg, rgba(197, 197, 197, 0.5) 0%, rgba(197, 197, 197, 0.05) 100%);\n    backdrop-filter: blur(65px);\n    display: flex;\n    flex-direction: column;\n}\n\n.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .block-timer__item .time {\n    font-weight: 600;\n    text-align: center;\n}\n\n.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .block-timer__item .time-label {\n    font-size: 12px;\n    text-align: center;\n    margin-top: 16px;\n}\n\n.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .two-dots {\n    font-size: 36px;\n    font-weight: 600;\n    line-height: 48px;\n}\n\n.BC-Page__CountdownNewModal .countdown-preview-side__product-page__content .preview-box .countdown-preview-side__product-page__button {\n    margin-top: 16px;\n    font-weight: 500;\n    padding: 10px;\n    width: 100%;\n    border-radius: 4px;\n    border: 0;\n    cursor: pointer;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    line-height: normal;\n}\n\n\n.BC-Page__CountdownNewModal .BC-CountdownReviewAppBlock .Polaris-Page {\n    background-color: #fff;\n    padding: 24px;\n}\n\n.BC-Page__CountdownNewModal .BC-CountdownReviewAppBlock .Polaris-Page .Polaris-Page__Content {\n    padding: 0;\n}\n\n.BC-CountdownReviewAppBlock__Head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.BC-CountdownReviewAppBlock__Steps {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.BC-CountdownReviewAppBlock__Step {\n    border-radius: 12px;\n    overflow: hidden;\n    background: #FAFBFB;\n}\n\n.BC-CountdownReviewAppBlock__Step.open {\n    border-color: var(--p-border, #c9cccf);\n}\n\n.BC-CountdownReviewAppBlock__StepActivator {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 20px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.BC-CountdownReviewAppBlock__StepActivator:hover {\n    background-color: var(--p-surface-hovered, #f6f6f7);\n}\n\n\n.BC-CountdownReviewAppBlock__StepActivator .BC-CountdownReviewAppBlock__Incomplete {\n    border: 2px dashed #8C9196;\n    border-radius: 50%;\n    width: 18px;\n    height: 18px;\n}\n\n.BC-CountdownReviewAppBlock__StepTitle {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--p-text, #202223);\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.BC-CountdownReviewAppBlock__StepTitle .Polaris-Icon {\n    margin: 0;\n}\n\n.BC-CountdownReviewAppBlock__StepToggle {\n    flex-shrink: 0;\n}\n\n.BC-CountdownReviewAppBlock__StepContent {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 24px;\n    padding: 0 20px 20px;\n}\n\n.BC-CountdownReviewAppBlock__StepLeft {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.BC-CountdownReviewAppBlock__StepLeft p {\n    margin: 0;\n    line-height: 1.5;\n}\n\n.BC-CountdownReviewAppBlock__StepLeft ul {\n    padding-left: 16px;\n}\n\n.BC-CountdownReviewAppBlock__StepRight {\n    flex-shrink: 0;\n    max-width: 340px;\n}\n\n.BC-CountdownReviewAppBlock__StepRight img {\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n    border: 1px solid var(--p-border-subdued, #dde0e4);\n    cursor: pointer;\n}\n\n.BC-CountdownReviewAppBlock__StepLeft .Polaris-Button {\n    max-width: max-content;\n}\n\n.BC-CountdownReviewAppBlock__StepDone {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    color: var(--p-text-success, #008060);\n}\n\n.BC-CountdownReviewAppBlock__Steps .Polaris-Icon {\n    margin: 0;\n}\n\n.BC-Page__CountdownNewModal .timer-wrapper .Polaris-TextField {\n    padding-right: 0;\n}\n\n@media (min-width: 40em) {\n    .BC-Page__CountdownNewModal .Polaris-FormLayout .countdown-timer-type__setting-time-box .countdown-timer-type__setting-time-box__daily .rc-time-picker-input {\n        font-size: var(--p-font-size-3);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
